<app-review-wrapper title="Schedule" [complete]="everyMessageScheduled" (onEdit)="navigateToUrl()">
  <p class="rs__lead">
    Runs <strong>{{ run }}</strong>
    @if (runLength) {
      ({{ runLength }})
    }
  </p>

  @if (groups.length) {
    <ol class="rs__items">
      @for (group of groups; track group.id) {
        <li class="rs__item">
          <p class="rs__item-title">{{ group.subject }}</p>
          <ul class="rs__times">
            @for (time of group.times; track $index) {
              <li>
                <span>{{ time.label }}</span>
                <span class="rs__countdown" [class.is-past]="time.past">
                  {{ time.past ? "already passed" : time.countdown }}
                </span>
              </li>
            }
          </ul>
        </li>
      }
    </ol>
  } @else {
    <p class="rs__lead">No send times yet.</p>
  }
</app-review-wrapper>
